// extracted by mini-css-extract-plugin
export default {"CurrentDoctor":"CurrentDoctor_CurrentDoctor__o1CDD"};